import { BaseFormStyled } from "./base-form.styles"
import { BaseFormProps } from "./types"

const BaseForm: React.FC<BaseFormProps> = ({ children }) => {
    return (
        <BaseFormStyled className="base-form">
            {children}
        </BaseFormStyled>
    )
}

export default BaseForm